var pmore_en = "View more";
var pmore_es = "Ver mas";

var pless_en = "View less";
var pless_es = "Ver menos";

var cookie_en = "This website uses cookies to ensure you get the best experience on our website.";
var cookie_es = "Este sitio web utiliza cookies";

var cookie_more_en = "Learn more";
var cookie_more_es = "Ver mas";

var cookie_acc_es = "Acepto";
var cookie_acc_en = "Accept";

function translate(key){
  
  
  var locale = 'es';
  
  console.log(window.location.href.indexOf("en\/"));
  if (typeof Shopify == 'undefined')
  {
  	if (window.location.href.indexOf("en\/") > -1)
    	locale = 'en';
    
                }
    else
  	var locale = Shopify.locale;
  

  
  
  return eval(key + '_' + locale);
}